import { render } from "./LeaveApprovalConfirmationModel.vue?vue&type=template&id=64d34220&scoped=true"
import script from "./LeaveApprovalConfirmationModel.vue?vue&type=script&lang=js"
export * from "./LeaveApprovalConfirmationModel.vue?vue&type=script&lang=js"

import "./LeaveApprovalConfirmationModel.vue?vue&type=style&index=0&id=64d34220&lang=scss&scoped=true"

import exportComponent from "/opt/lampp/htdocs/gslhrm/v6061/src/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-64d34220"]])

export default __exports__